// extracted by mini-css-extract-plugin
export default {"rating":"Qz-z","numberOfStars":"Rz-z","count":"Sz-z","barGraphSpacing":"Tz-z","barGraph":"Uz-z"};